import { type BackendExperiment, type ExperimentLayer } from '../../../types';
import { getLayerValues } from '../backend';

import { type DynamicExperiments, type ProductEdition } from './types';

export const mapDynamicToBackendExperiment = (
	dynamicExperiments: DynamicExperiments,
	productEdition?: ProductEdition,
): BackendExperiment => {
	const experimentLayers = dynamicExperiments
		.filter((dynamicExp) => {
			// Opt for specificity. Does not filter out values that do not have the confluenceTier attribute
			if (!dynamicExp.confluenceTier || dynamicExp.confluenceTier.length === 0) {
				return true;
			}
			return dynamicExp.confluenceTier?.find(
				(experimentTier) => productEdition?.['confluence'] === experimentTier,
			);
		})
		.map((dynamicExp): ExperimentLayer => getLayerValues(dynamicExp.statsigLayerId));

	return {
		experimentId: experimentLayers.map((layer) => layer.layerId).join('_'),
		shadowExperimentId: experimentLayers.map((layer) => layer.shadowId).join('_'),
		experimentLayers,
	};
};
